import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return '—';
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(date));
}

export function formatDateTime(date: string | Date | null | undefined): string {
  if (!date) return '—';
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(date));
}

export function formatScore(score: number | null | undefined): string {
  if (score == null) return '—';
  return score.toFixed(0);
}

export function truncate(str: string, maxLength: number): string {
  if (str.length <= maxLength) return str;
  return str.slice(0, maxLength - 1) + '…';
}

export function scoreColor(score: number | null | undefined): string {
  if (score == null) return 'text-text-secondary';
  if (score >= 800) return 'text-accent-emerald';
  if (score >= 600) return 'text-accent-sky';
  if (score >= 400) return 'text-accent-amber';
  return 'text-accent-rose';
}

export function scoreBgColor(score: number | null | undefined): string {
  if (score == null) return 'bg-border-subtle';
  if (score >= 800) return 'bg-accent-emerald-dim';
  if (score >= 600) return 'bg-accent-sky-dim';
  if (score >= 400) return 'bg-accent-amber-dim';
  return 'bg-accent-rose-dim';
}

export function getInitials(name: string): string {
  return name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
